<template>
  <v-text-field
    v-model.number="intValue"
    class="quantity"
    hide-details
    height="50"
    @change="$emit('input', intValue)"
  >
    <v-icon
      slot="append-outer"
      color="primary"
      class="icon-position"
      icon
      size="40"
      @click="increment"
    >
      add_box
    </v-icon>
    <v-icon
      slot="prepend"
      color="primary"
      class="icon-position"
      icon
      size="40"
      @click="decrement"
    >
      indeterminate_check_box
    </v-icon>
  </v-text-field>
</template>

<script>
export default {
  name: 'CountIncrement',

  props: {
    value: {
      default: 1,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    }
  },

  data () {
    return {
      intValue: 0
    }
  },
  computed: {
    canIncrement () {
      return (this.max === undefined || ((this.intValue + this.step) <= this.max))
    },

    canDecrement () {
      return ((this.intValue - this.step) >= this.min)
    }
  },

  watch: {
    value: {
      handler: function (newVal) {
        this.intValue = newVal
      }
    }
  },

  mounted () {
    this.intValue = this.value
    if (this.step < 1) this.step = 1
    if (this.max < this.min) this.max = undefined
  },

  methods: {
    increment () {
      if (this.canIncrement) {
        this.intValue = this.intValue + this.step
        this.$emit('input', this.intValue)
      }
    },

    decrement () {
      if (this.canDecrement) {
        this.intValue = this.intValue - this.step
        this.$emit('input', this.intValue)
      }
    }
  }
}
</script>

<style>
.quantity input {
  padding-bottom: 2px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
</style>
